<template>
  <widget-base
    :title="cTitle"
    :subtitle="sub"
    :shadow="shadow"
    :titlePosition="titlePosition"
    :showNoData="showNoData"
    :initialFilters="data.filters"
    :interval="interval"
    :filteringEnabled="this.filteringEnabled"
    @set-filters="val => (filters = val)"
    @set-cleaned-filters="val => (cleanedFilters = val)"
    @set-interval="val => (interval = val)"
    showIntervalSelector
    class="chart-wrapper"
  >
  <div class="failText" v-if="showNoData">
      {{$t('chart_error')}}
    </div>
    <chart-scatter
      v-if="tooltipsOptions"
      :chart-id="uniqueID"
      :chart-data="dataCollection"
      :options="{
        legend: false,
        fullCornerRadius: false,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: tooltipsOptions(title),
        scales: scalesOptions()
      }"
    />
  </widget-base>
</template>

<script>
import ChartWidget from "../../mixins/ChartWidget";
import _ from "lodash";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "ScatterChart",
  mixins: [ChartWidget],
  props: {},
  data: () => ({
    baseID: "scatter-chart"
  }),
  computed: {
    plugins: () => [ChartDataLabels]
  },
  methods: {
    fillData(widgetData) {
      let canvas = document.getElementById(this.uniqueID);
      canvas.parentNode.style.height = "400px";

      this.dataCollection = {
        ...widgetData.data,
        datasets: this.$_.map(widgetData.data.datasets, ds => {
          return {
            ...ds,
            pointBorderColor: "#084081",
            pointBackgroundColor: "#084081"
          };
        })
      };
      this.loading = false;
    }
  }
};
</script>
